export const DEFAULT_NODE_WIDTH = 300;
export const DEFAULT_NODE_HEIGHT = 270;
